import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { ToolService } from '../../services/tool/tool.service';
import { HttpJavaService } from '../../services/http-java-service/http-java.service';
import { UserTranslationService } from '../../services/user-translation/user-translation.service';

@Component({
  selector: 'app-tutorials',
  templateUrl: './tutorials.component.html',
  styleUrls: ['./tutorials.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TutorialsComponent {

  tutorials: any[] = [];

  public isLoading: boolean = true;
  public filterQuery = '';
  public btnLang: string;
  public langDir: string = "ltr";
  title = 'ng';
  langs = ['en', 'ar'];
  public countryList = [
    { labelEn: 'Bahrain', labelAr: 'البحرين', value: 'BH', },
    { labelEn: 'Saudi Arabia', labelAr: 'السعودية', value: 'SA', },
    { labelEn: 'UAE', labelAr: 'الإمارات', value: 'AE', },
    { labelEn: 'Qatar', labelAr: 'قطر', value: 'QA', },
    { labelEn: 'Kuwait', labelAr: 'الكويت', value: 'KW', },
    { labelEn: 'Oman', labelAr: 'عمان', value: 'OM', },
  ];
  isEnglishLang: boolean = true;
  selectedCountry: string = this.countryList[0].value;

  public ngOnInit(): void {
    let browserlang = this.translateService.getBrowserLang();
    if (this.langs.indexOf(browserlang) > -1) {
      this.translateService.setDefaultLang(browserlang);
      this.btnLang = 'English';
      this.langDir = 'rtl';
    } else {
      this.translateService.setDefaultLang('en');
      this.btnLang = "العربية";
      this.langDir = 'ltr';
    }
  }

  constructor(
    public translateService: TranslateService,
    public titleService: Title,
    public router: Router,
    public route: ActivatedRoute,
    private httpJavaService: HttpJavaService,
    public toolService: ToolService,
    public userTranslationService: UserTranslationService,
  ) {
    this.isLoading = true;
    this.loadAllTutorials();
  }
  @ViewChild('dangerModal', { static: false }) public dangerModal: ModalDirective;


  loadAllTutorials = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.httpJavaService.getAllTutorials(this.selectedCountry)
        .then(res => {
          this.tutorials = (res.data.content || []);
          this.isLoading = false;
          resolve(res);
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => this.isLoading = false);
    });
  }

  public getDate(regDate: string) {
    const date = new Date(regDate);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit', });
  }


  public showEdit(data: object) {
    this.router.navigate(['detail'], { state: { tutorial: data, country: this.selectedCountry }, relativeTo: this.route });
  }
  public add() {
    this.router.navigate(['detail'], { state: {}, relativeTo: this.route });
  }
}
